module.exports = "https://web-assets.ifttt.com/packs/media/icons/icon-plus-fa87420e.svg";